"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var queryString = require("query-string");
var apiConfig_1 = require("./apiConfig");
/**
 * 聪明派API客户端
 *
 * @class ApiClient
 */
var OrderApiClient = /** @class */ (function (_super) {
    __extends(OrderApiClient, _super);
    function OrderApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 下单
     *
     * @param {string} skuId
     * @returns {Promise<void>}
     * @memberof ApiClient
     */
    OrderApiClient.prototype.createOrder = function (skuId, paymentMethod, options) {
        return __awaiter(this, void 0, void 0, function () {
            var url, couponId, groupPurchaseId, buyerId, relationshipId, appId, mobile, isSpecial, quitUrl, returnUrl, requestData, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = OrderApiClient.API_BASE_URL + "/orders";
                        if (options.weappQueryString) {
                            url = OrderApiClient.API_BASE_URL + "/orders?" + options.weappQueryString;
                        }
                        couponId = options.couponId, groupPurchaseId = options.groupPurchaseId, buyerId = options.buyerId, relationshipId = options.relationshipId, appId = options.appId, mobile = options.mobile, isSpecial = options.isSpecial, quitUrl = options.quitUrl, returnUrl = options.returnUrl;
                        requestData = {
                            appId: appId,
                            couponId: couponId,
                            groupPurchaseId: groupPurchaseId,
                            relationshipId: relationshipId,
                            paymentMethod: paymentMethod,
                            mobile: mobile,
                            buyerId: buyerId,
                            isSpecial: isSpecial,
                            quitUrl: quitUrl,
                            returnUrl: returnUrl,
                            skuIds: [skuId],
                        };
                        return [4 /*yield*/, this.requestAdaptor({
                                url: url,
                                method: 'POST',
                                data: requestData,
                            })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /**
     * 获取订单详情
     *
     * @param {string} orderId
     * @returns {Promise<Order>}
     * @memberof ApiClient
     */
    OrderApiClient.prototype.getOrder = function (orderId) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = OrderApiClient.API_BASE_URL + "/orders/" + orderId;
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /**
     * 查询是否是付费用户
     *
     * @param {string} id
     * @returns {Promise<Paid>}
     * @memberof ApiClient
     */
    OrderApiClient.prototype.getUserPaidStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = OrderApiClient.API_BASE_URL + "/users/tags/paid";
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /**
     * 获取c3报价
     * @param {number} { skuIds:number[]; activityId:number}
     * @returns
     * @memberof URLs
     */
    OrderApiClient.prototype.getPresellQuote = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = OrderApiClient.API_BASE_URL + "/orders/quote";
                        return [4 /*yield*/, this.requestAdaptor({ url: url, data: data, method: 'POST' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /**
     * 获取c3报价
     * @param data
     * @param {number[]} data.skuIds
     * @returns Promise
     * @memberof URLs
     */
    OrderApiClient.prototype.getPresellNormalQuote = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = OrderApiClient.API_BASE_URL + "/orders/quote";
                        return [4 /*yield*/, this.requestAdaptor({ url: url, data: data, method: 'POST' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data]; // PresellOrder
                }
            });
        });
    };
    /**
     * 创建c3普通订单
     * @param {number} { skuIds:number[]; activityId:number}
     * @returns
     * @memberof URLs
     */
    OrderApiClient.prototype.createPresellNormalOrder = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = OrderApiClient.API_BASE_URL + "/orders";
                        return [4 /*yield*/, this.requestAdaptor({ url: url, data: data, method: 'POST' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /**
     * 创建c3预定订单
     * @param {number} { skuIds:number[]; preorderId:number}
     * @returns
     * @memberof URLs
     */
    OrderApiClient.prototype.createPresellPreorderOrder = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = OrderApiClient.API_BASE_URL + "/orders/" + data.preorderId + "/pay";
                        return [4 /*yield*/, this.requestAdaptor({ url: url, data: data, method: 'POST' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    OrderApiClient.prototype.getOrderShareData = function (userUuid, orderId) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = OrderApiClient.API_BASE_URL + "/share/order/" + orderId + "/" + userUuid;
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    /**
     * 获取用户当前课程订单
     * @returns
     * @memberof URLs
     */
    OrderApiClient.prototype.getUserOrders = function (skuGroupNames) {
        return __awaiter(this, void 0, void 0, function () {
            var query, url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = queryString.stringify({ skuGroupNames: skuGroupNames });
                        url = OrderApiClient.API_BASE_URL + "/orders/fulfilled?" + query;
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    OrderApiClient.prototype.getProductOrder = function (orderId) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = OrderApiClient.API_BASE_URL + "/orders/product/" + orderId;
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    return OrderApiClient;
}(apiConfig_1.ApiConfig));
exports.OrderApiClient = OrderApiClient;
//# sourceMappingURL=order.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/services/api/order.js
// module id = 1026
// module chunks = 0